/**
 * Klantvereisten per project (23 okt 2026, Schneider Electric approved supplier).
 * Eén gedeelde cache per project (record-id, anders nummer), zodat de draaidagkaarten op één
 * projectpagina samen één verzoek doen. Na een AI-log- of NDA-wijziging: wisKlantVereisten().
 */
import { BACKEND_URL } from './apiConfig';
import { authFetch } from './authHelpers';
import { leesJson } from './apiFout';

const TTL = 60 * 1000;
const cache = new Map();

export function sleutelVan({ projectId, nummer }) {
  return projectId ? `id:${projectId}` : (nummer ? `nr:${nummer}` : null);
}

export function haalKlantVereisten({ projectId, nummer }) {
  const sleutel = sleutelVan({ projectId, nummer });
  if (!sleutel) return Promise.resolve({ klantgroep: null });
  const hit = cache.get(sleutel);
  if (hit && Date.now() - hit.t < TTL) return hit.p;
  const params = new URLSearchParams();
  if (projectId) params.set('projectId', projectId);
  if (nummer) params.set('nummer', nummer);
  const p = authFetch(`${BACKEND_URL}/Api/klantvereisten/voor-project?${params}`)
    .then((r) => leesJson(r, 'Klantvereisten laden'))
    .catch((e) => { cache.delete(sleutel); throw e; });
  cache.set(sleutel, { t: Date.now(), p });
  return p;
}

export function wisKlantVereisten() {
  cache.clear();
}

/** NDA-regel in gewone taal; null als er niets te zeggen valt. */
export function ndaRegel(nda) {
  if (!nda) return null;
  switch (nda.status) {
    case 'ontbreekt':
      return { ernst: 'let-op', tekst: `Geheimhouding ontbreekt: ${nda.ontbreekt.slice(0, 4).join(', ')}${nda.ontbreekt.length > 4 ? ` +${nda.ontbreekt.length - 4}` : ''} — tekenen vóór de briefing` };
    case 'controleren':
      return { ernst: 'stil', tekst: `Geheimhouding controleren: ${nda.controleren.slice(0, 4).join(', ')}` };
    case 'compleet':
      return { ernst: 'stil', tekst: `Geheimhouding: ${nda.freelancers.length === 1 ? 'de freelancer heeft' : `alle ${nda.freelancers.length} freelancers hebben`} getekend` };
    case 'geen_freelancers':
      return { ernst: 'stil', tekst: 'Nog geen freelancers gekoppeld — die tekenen vóór de briefing' };
    case 'niet_beschikbaar':
      return { ernst: 'stil', tekst: 'Geheimhouding kon nu niet gecontroleerd worden' };
    default:
      return null;
  }
}

/** Namen zonder verklaring die op een bepaalde draaidag (JJJJ-MM-DD) staan. */
export function ontbrekendOpDag(nda, datum) {
  if (!nda || !datum) return [];
  return (nda.freelancers || [])
    .filter((f) => f.status === 'ontbreekt' && (f.datums || []).includes(datum))
    .map((f) => f.naam);
}
